module.exports = __webpack_public_path__ + "static/media/dummyPython.d27bf808.png";